<template>
  <div>
    <b-container fulid class="bv-example-row about">
      <div class="ptit">易梯配-电梯配件交易平台</div>
      <b-row>
        <b-col
          cols="12"
          sm="12"
          md="12"
          lg="6"
          xl="6"
          style="padding-bottom: 15px; background-color: #fff"
        >
          <div class="jieshao">
            <div class="p2">易梯配</div>
            <p class="p2">
              是专门从事电梯配件线上销售的B2B电商平台，
              隶属于北京易梯科技有限公司，并致力于改变多年来电梯配件传统的销售模式，
              寄望发展成为专业电梯维保单位的配件采购顾问，
              第三方技术支援平台及电梯配件的线上交易大咖，愿以微薄之力为电梯行业的发展出一份心意。近年来国内电梯的需求持续增长，随之而来的配件市场也逐步火热起来，而电梯维保单位对电梯配件的品牌所知寥寥，对其价格的高低和新旧无法掌控，处于被动局面，即使被无良商家坑骗也无处维权，相对的很多电梯配件经销商，线下销售的价格尴尬和卖出数量日益减少，销售渠道屈指可数。
              是专门从事电梯配件线上销售的B2B电商平台，隶属于北京易梯科技有限公司，并致力于改变多年来电梯配件传统的销售模式，寄望发展成为专业电梯维保单位的配件采购顾问,第三方技术支援平台及电梯配件的线上交易大咖，愿以微薄之力为电梯行业的发展出一份心意。近年来国内电梯的需求持续增长，随之而来的配件市场也逐步火热起来.而电梯维保单位对电梯配件的品牌所知寥寥对其价格的高低和新旧无法掌控，处于被动局面，即使被无良商家坑骗也无处维权:相对的很多电梯配件经销商，线下销售的价格尴尬和卖出数量日益减少，销售渠道屈指可数。因此易梯推出配件交易电商平台一易梯配。
              易梯配依托易梯平台为客户提供高品质的配件采购服务，易梯配秉承着”价格优、服务好、-站式采购”的经营理念,打造成为电梯配件中的“京东
            </p>
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="12"
          md="12"
          lg="6"
          xl="6"
          class="yuansu"
          style="position: relative"
        >
          <b-row style="height: inherit">
            <b-col
              cols="12"
              sm="12"
              md="12"
              lg="6"
              xl="6"
              style="padding: 0px 36px; background-color: #1a5fdc9e"
            >
              <div class="gao">
                <div class="p3">27万+</div>
                <div class="p4">行业用户</div>
              </div>
              <div class="gao">
                <div class="p3">12000+</div>
                <div class="p4">电梯配件</div>
              </div>
              <div class="gao">
                <div class="p3">全媒体</div>
                <div class="p4">推广渠道</div>
              </div>
            </b-col>
            <!-- <b-img class="shang" :src="zhao"></b-img> -->
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "introduce",
  data() {
    return {
      img_1: require("../../../stater/jeshao.png"),
      zhao: require("../../../stater/zhao_phon.png"),
    };
  },
};
</script>
<style scoped>
.about {
  margin-bottom: 9px;
  padding: 0;
  width: 67%;
}
@media screen and (max-width: 990px) {
  .about {
    margin-bottom: 9px;
    padding: 0;
    width: 87%;
  }
}

.ptit {
  font-size: 22px;
  font-weight: 500;
  width: 100%;
  /* margin-bottom: 17px; */
  background-color: rgb(248, 249, 250);
  line-height: 58px;
  white-space: nowrap;
}
.jieshao {
  height: 299px;
  overflow-y: scroll;
  padding: 12px;
}
.jieshao::-webkit-scrollbar {
  width: 3px;
}
.jieshao::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgb(2, 107, 185);
  background: rgb(2, 107, 185);
}
.jieshao::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.yuansu {
  background-image: url(../../../stater/jeshao.png);
  background-size: 100% 100%;
  height: 19rem;
  /* opacity: 0.2; */
}
.meng {
  position: absolute;
  width: 248px;
  height: 276px;
  background-color: #000000b0;
}
.imgs {
  height: 19rem;
  width: 34rem;
}
.imgs::after {
  content: "";
  display: inline;
  width: 17rem;
  height: 24rem;
  background-color: black;
}
.p1 {
  text-align: left;
  font-size: 40px;
  color: blue;
  font-weight: 600;
}

.rowwhy {
  display: flex;
  justify-content: center;
  margin-top: 26px;
}

.p2 {
  text-align: left;
  line-height: 30px;
  font-size: 13px;
}
.p3 {
  font-size: 25px;
  font-weight: 500;
  color: #fff;
  border-bottom: 1px solid #fff;
  line-height: 52px;
}
.gao {
  margin: 8px 0;
}
.p4 {
  color: #fff;
  line-height: 35px;
  font-size: 13px;
}
.spans {
  font-size: 40px;
  color: rgba(0, 0, 0, 0.623);
}

.shuiyin {
  position: absolute;
  top: 1rem;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
}
.shuiyin-item {
  color: #999;
  opacity: 0.3;
  pointer-events: none;
  display: block;
  width: 300px;
  height: 50px;
  line-height: 50px;
  font-size: 98px;
  font-weight: 500;
  margin-left: 53px;
  letter-spacing: 14px;
}
.shang {
  right: -7.6rem;
  bottom: 0;
  width: 123px;
  position: absolute;
}
@media screen and (max-width: 851px) {
  .shang {
    display: none;
  }
}
@media screen and (max-width: 670px) {
  .shuiyin-item {
    font-size: 43px;
    margin-left: 9px;
    letter-spacing: 11px;
  }
  .p1 {
    font-size: 27px;
    text-align: center;
  }
  .spans {
    font-size: 27px;
  }
  .imgs {
    margin: 0 auto;
  }
}
</style>